import type { RouteRecordRaw } from "vue-router"

const Account = () => import("./views/Account.vue")
const AddNewDevice = () => import("./views/AddNewDevice.vue")

const routes = (options: {
  backLocation: { name: string }
}): RouteRecordRaw[] => {
  return [
    {
      path: "accounts/",
      component: Account,
      name: "accounts:home",
      props: { back: options.backLocation },
    },
    {
      path: "accounts/new-device/",
      component: AddNewDevice,
      name: "accounts:add-new-device",
    },
  ]
}

export default routes
